
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import {
  setGcashGroup,
  addGcashGroup,
  delGcashGroup,
  getAllGcash
} from '@/api/gcash/groups'
import { editMultipleGcashAccount } from '@/api/gcash/account'
import { AppModule } from '@/store/modules/app'
import { delObjEmptyKey } from '@/utils'

@Component({
  name: 'group',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) list!: any
  get language() {
    return AppModule.language
  }

  private dynamic1: any = 0
  private itemInfo: any = {}
  private clickItem(item: any, index: any) {
    this.dynamic1 = index
    this.itemInfo = item
    this.newList = this.list.filter(item => {
      return item.gcash_groups === this.itemInfo.id
    })
    this.checkAll = this.newList.length === this.list.length
    this.isIndeterminate = this.newList.length > 0 && this.newList.length < this.list.length
  }

  private isindex: any = null
  private editGroupName(index) {
    this.isindex = index
  }
  // private onBlur (id) {
  //   this.isindex = null
  //   this.onloadGroupList()
  // }

  private loading: boolean = false
  // 源对象的下标
  private dragIndex: any = ''
  // 目标对象的下标
  private enterIndex: any = ''
  private timeout: any = null
  private back() {
    this.newList = []
    this.$emit('close')
  }

  private groupList: any = []
  private async onloadGroupList() {
    try {
      let params: any = {
        page_size: 100,
        page: 1
      }
      await getAllGcash(params).then((res: any) => {
        this.groupList = res.results
      })
    } catch (e) {
      console.log()
    }
  }

  // 判断是否是编辑或者创建
  private groupName: string = ''
  private groupId: any = null
  private async createGroup() {
    if (this.groupName === '') { return this.$message.error('Please select a group name') }
    try {
      const data: any = {
        group_name: this.groupName
      }
      await addGcashGroup(data).then(() => {
        this.$message({
          message: 'Create Successful!',
          type: 'success'
        })
        this.onloadGroupList()
      })
    } catch (e) {
      console.log()
    }
  }
  private async editGroup() {
    if (this.groupName === '') { return this.$message.error('Please select a group name') }
    try {
      const data: any = {
        id: this.groupId,
        group_name: this.groupName
      }
      await setGcashGroup(data).then(() => {
        this.$message({
          message: 'Edit Successful!',
          type: 'success'
        })
      })
    } catch (e) {
      console.log()
    }
  }
  private async changeGroupName(val, id) {
    this.groupName = val
    this.groupId = id
  }

  // 删除账户组
  private del(id: number) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          const data: any = {
            id: id
          }
          if (action === 'confirm') {
            delGcashGroup(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.onloadGroupList()
            })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          const data: any = {
            id: id
          }
          if (action === 'confirm') {
            delGcashGroup(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.onloadGroupList()
            })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的 ',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          const data: any = {
            id: id
          }
          if (action === 'confirm') {
            delGcashGroup(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Delete successful!'
              })
              this.onloadGroupList()
            })
          }
        }
      })
    }
  }

  private checkAll: any = false
  private isIndeterminate: any = true
  private newList: any = []
  handleCheckAllChange(val) {
    this.newList = val ? this.list : []
    this.isIndeterminate = false
  }
  handleCheckedCitiesChange(value) {
    let checkedCount = value.length
    this.checkAll = checkedCount === this.list.length
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length
    this.newList = value
  }

  private async empty() {
    try {
      if (!this.groupList[this.dynamic1]) { return this.$message.error('Please select group!') }
      if (this.newList.length === 0) { return this.$message.error('Please select the account number!') }
      let arr: any = []
      this.newList.forEach(item => {
        arr.push({
          gcash_groups: this.itemInfo.id,
          account_id: item.account_id,
          phone_number: item.phone_number,
          account_password: item.account_password,
          id: item.id
        })
      })
      const data: any = {
        ...arr
      }
      delObjEmptyKey(data)
      await editMultipleGcashAccount(data).then((res: any) => {
        this.back()
      })
    } catch (error) {
      console.log()
    }
  }

  private openAdd() {
    this.groupList.push({
      group_name: ''
    })
    this.isindex = this.groupList.length - 1
  }
  private dragstart(index) {
    console.log('start index ===>>> ', index)
    this.dragIndex = index
  }

  // dragenter 和 dragover 事件的默认行为是拒绝接受任何被拖放的元素。
  // 因此，我们要在这两个拖放事件中使用`preventDefault`来阻止浏览器的默认行为
  private dragenter(e, index) {
    e.preventDefault()
    this.enterIndex = index
    if (this.timeout !== null) {
      clearTimeout(this.timeout)
    }
    // 拖拽事件的防抖
    this.timeout = setTimeout(() => {
      if (this.dragIndex !== index) {
        const source = this.groupList[this.dragIndex]
        this.groupList.splice(this.dragIndex, 1)
        this.groupList.splice(index, 0, source)
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index
      }
    }, 100)
  }
  private dragover(e, index) {
    e.preventDefault()
  }

  mounted() {
    this.dynamic1 = null
    this.onloadGroupList()
  }
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timeout)
    this.timeout = null
  }
}
